module.exports = __webpack_public_path__ + "static_portal/img/cycling.d8765c85.svg";